import { createSlice } from "@reduxjs/toolkit";
import { tasksAction } from "../actions/taskActions";

const initialState = {
  patientModalOpen: false,
  patientModalSerialNumber: null,
  selectedTask: {
    id: "",
    description: "",
    status: "",
    account: "",
    notes: "",
  },
  taskModalOpen: false,
  requestType: "PUT",
  taskModalTitle: "Update Task Information",
  filters: [],
  selectedRowIds: [],
  singleTaskArchive: false,
  isLoading: false,
  refetchTasks: false,
  archiveModalOpen: false,
  searchText: "",
};

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: tasksAction,
});

export const {
  openTaskModal,
  setLoading,
  setTableFilters,
  closeTaskModal,
  setSelectedTask,
  setRefetchTasks,
  setSelectedRowIds,
  setArchiveModalOpen,
  setSingleTaskArchive,
  changeSearch,
} = taskSlice.actions;

export default taskSlice.reducer;
